import { render, staticRenderFns } from "./inspectionManage.vue?vue&type=template&id=89475644&scoped=true&"
import script from "./inspectionManage.vue?vue&type=script&lang=js&"
export * from "./inspectionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89475644",
  null
  
)

export default component.exports